import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import useResult from "../hooks/useResult";
import usePetAid from "../hooks/usePetAid";
import {getUrlParam} from "../constants/helpers";
import {CLIENT_HOST} from "../constants/constants";
import {ThemeContext} from "./ThemeContext";
import ReactGA from "react-ga";
import {useLocation} from "react-router-dom";
import {useMediaQuery, useTheme} from "@material-ui/core";
import usePetAidCommentary from "../hooks/usePetAidCommentary";


export const getBookAbbrevAndChapterNumber = (pathname) => {
  const pathParts = decodeURI(pathname).split("/").filter(Boolean);
  const lastPathPart = pathParts[pathParts.length - 1];
  const isLastPartChapter = !isNaN(lastPathPart);
  let latestBookAbbrev = pathParts[0];
  let latestChapterNumber = isLastPartChapter ? parseInt(lastPathPart, 10) : null;
  if (pathParts.length > 1 && !isLastPartChapter) {
    latestBookAbbrev = `${pathParts[0]} ${pathParts[1]}`;
    latestChapterNumber = pathParts.length > 2 ? parseInt(pathParts[2], 10) : null;
  }
  return { latestBookAbbrev, latestChapterNumber };
}
export const SearchContext = createContext({});
export const SearchContextProvider = ({ children, props }) => {
  const theme = useTheme();
  const matchSM = useMediaQuery(theme.breakpoints.down('xs'));
  
  const [sharedPatientData, setSharedPatientData] = useState(undefined)
  
  
  //not used below?
  
  
  const [bookAbbrev, setBookAbbrev] = useState( '')
  const [chapterNumber, setChapterNumber] = useState( '')
  const location = useLocation();
  
  
  useEffect(()=>{
    const { latestBookAbbrev, latestChapterNumber } = getBookAbbrevAndChapterNumber(location.pathname);
    setBookAbbrev(latestBookAbbrev)
    setChapterNumber(latestChapterNumber)
  },[location.pathname])
  
  
  useEffect(() => {
    if (!window.location.hostname.includes("localhost")) { /* Production Only */
      const adjustedURL = directLink.split(/\.ai\/?|\.dev\/?/);
      //ReactGA.initialize('UA-154880-13');
      //ReactGA.pageview(adjustedURL[1]);
    }
  },[location.pathname])
  
  const { data: bibleGPTData, isLoading: bibleGPTLoading } = usePetAid(bookAbbrev, chapterNumber);
  const { data: bibleGPTCommentaryData, isLoading: bibleGPTCommentaryLoading } = usePetAidCommentary(bookAbbrev, chapterNumber);
  
  const originalPageTitle = useMemo(()=>document.title,[])
  
  const [menuOpen, setMenuOpen] = useState( false)
  const toggleMenu = useCallback(()=>setMenuOpen(!menuOpen),[menuOpen])
  
  const [query, setQuery] = useState( '')
  const [debounceQuery, setDebounceQuery] = useState('');
  
  useEffect(() => {
    if(getUrlParam('q')){
      setQuery(getUrlParam('q'))
    }
  }, []);
  
  useEffect(() => {
    const newUrl = new URL(window.location.href);
    if (query) {
      newUrl.searchParams.set("q", query);
    } else {
      newUrl.searchParams.delete("q");
    }
    window.history.pushState({}, "", newUrl);
  }, [query]);
  
  
  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setDebounceQuery(query);
      document.title = debounceQuery ?  debounceQuery + " - PetAid.ai" : originalPageTitle
    }, 1000);
    
    return () => {
      clearTimeout(timeOutId);
    };
  }, [query, originalPageTitle]);
  
  const { darkMode } = useContext(ThemeContext);
  const directLink = useMemo(()=>{
      return `${CLIENT_HOST}/?q=${debounceQuery}&t=${darkMode ? 'dark' : 'light'}`
  },[debounceQuery,darkMode])
  
  //nothing else below?
  
  
  
  
  const [companyCountryPhone, setCompanyCountryPhone] = useState('+1');
  
  
  const [page, setPage] = useState( 0);
  const [rowsPerPage, setRowsPerPage] = useState( 10);
  const [type, setType] = useState( '');
  const [locale, setLocale] = useState('en')
  const [filterExplicit, setFilterExplicit] = useState( true);
  const [timeRange, setTimeRange] = useState( 'any')
  const oneMonthAgo = useMemo(()=>{
       let d = new Date();
       d.setMonth(d.getMonth() - 1);
       return d.toISOString().substring(0,10);
  }
  ,[]);
  const [timeRangeCustomStart, setTimeRangeCustomStart] = useState(oneMonthAgo)
  const [timeRangeCustomEnd, setTimeRangeCustomEnd] = useState(new Date().toISOString().substring(0,10))
  const [indexCount, setIndexCount] = useState(0)
  const [entityCount, setEntityCount] = useState(0)
  const [trendingList, setTrendingList] = useState([])
  const [searchResults, setSearchResults] = useState(null)
  const [totalSearchResults, setTotalSearchResults] = useState(-1)
  const [showExtendedCategories, setShowExtendedCategories] = useState( false)
  
  //onload, over-ride defaults
  
  
  const trendData = []
  const trendsLoading = false
  //const { data: trendData, isLoading: trendsLoading } = useTrends();
  const { data: searchResultsObj, isLoading: resultsLoading } = useResult('', companyCountryPhone); // debounceQuery
  
  useEffect(() => {
   if(searchResultsObj){
     setSearchResults(searchResultsObj)
   }
  }, [searchResultsObj, resultsLoading]);
  
  useEffect(() => {
   if(trendData){
     setIndexCount(trendData.indexCount)
     setEntityCount(trendData.entityCount)
     setTrendingList(trendData.data)
   }
  }, [trendData]);
  
  const forceSearch = useCallback(value => {
    setDebounceQuery(query);
  },[query]);
  
  return (
    <SearchContext.Provider
      value={{
        actions: {
          setQuery,
          setTimeRange,
          setLocale,
          setFilterExplicit,
          forceSearch,
          setTrendingList,
          setPage,
          setType,
          setRowsPerPage,
          setTimeRangeCustomStart,
          setTimeRangeCustomEnd,
          setShowExtendedCategories,
          setCompanyCountryPhone,
          
          setMenuOpen,
          toggleMenu,
          setSharedPatientData
        },
        state: {
          query,
          debounceQuery,
          timeRange,
          locale,
          filterExplicit,
          timeRangeCustomStart,
          timeRangeCustomEnd,
          trendingList,
          searchResults,
          totalSearchResults,
          resultsLoading,
          trendsLoading,
          indexCount,
          entityCount,
          page,
          type,
          rowsPerPage,
          directLink,
          showExtendedCategories,
          companyCountryPhone,
          bibleGPTData,
          bibleGPTLoading,
          bibleGPTCommentaryLoading,
          bibleGPTCommentaryData,
          chapterNumber,
          bookAbbrev,
          matchSM,
          menuOpen,
          sharedPatientData
        },
      }}
      {...props}
    >
      {children}
    </SearchContext.Provider>
  );
};
